<template>
	<v-dialog 
		v-model="dialog"
		:fullscreen="fullscreen"
		:max-width="maxWidth"
		scrollable
		persistent
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<!-- <v-icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">{{ activatorIcon }}</v-icon> -->
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-import</v-icon>
						</v-btn>
					</slot>
				</template>
				<span>{{ tooltip | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" icon @click="onLoadSettings" >
							<v-icon>mdi-folder</v-icon>
						</v-btn>
					</template>
					<span>Завантаження налаштувань</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" icon @click="onSaveSettings" >
							<v-icon>mdi-content-save</v-icon>
						</v-btn>
					</template>
					<span>Збереження налаштувань</span>
				</v-tooltip>
				
				<v-divider vertical></v-divider>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-container>
					<v-card flat>
						<v-toolbar flat>
							<v-avatar>
								<v-icon large>mdi-file-excel</v-icon>
							</v-avatar>
							<v-toolbar-title>{{ file.name }}</v-toolbar-title>
							
							<v-spacer></v-spacer>
							<v-btn outlined @click="onLoadFile" >
								<v-icon>mdi-paperclip</v-icon>
								Завантажити
							</v-btn>
						</v-toolbar>
						<v-card-text>
							<v-tabs v-model="tab">
								<v-tab v-for="(sheet, six) in file.sheets" :key="six">
									{{ sheet.name }}
								</v-tab>
							</v-tabs>
							<v-tabs-items v-model="tab">
								<v-tab-item v-for="(sheet, six) in file.sheets" :key="six">
									<v-card flat>
										<v-card-text>
											<v-data-table
												:items="sheet.items"
												:headers="sheet.headers"
												:items-per-page="5"
											>
											<!-- show-select
												single-select -->
												<template v-slot:header="{ props: { headers } }">
													<thead>
														<tr>
															<th v-for="(header, i) in sheet.headers" :key="i">
																<v-select
																	v-model="header.field"
																	:items="fields"
																	item-text="name"
																	item-value="code"
																	hide-details="auto"
																	clearable
																	return-object
																></v-select>
															</th>
														</tr>
													</thead>
												</template>
											</v-data-table>
										</v-card-text>
										<v-card-text>
											<v-row>
												<v-col cols="12" md="2">
													<v-text-field
														v-model="sheet.row.start"
														label="Діапазон рядків з"
														hide-details="auto"
														type="number"
														min="1"
														:max="sheet.row.count"
													></v-text-field>
												</v-col>
												<v-col cols="12" md="2">
													<v-text-field
														v-model="sheet.row.end"
														label="Діапазон рядків по"
														hide-details="auto"
														type="number"
														min="1"
														:max="sheet.row.count"
													></v-text-field>
												</v-col>
											</v-row>
										</v-card-text>
										<v-divider></v-divider>
										<v-toolbar flat>
											<v-avatar>
												<v-icon large>mdi-table-sync</v-icon>
											</v-avatar>
											<v-toolbar-title>Дані для імпорту</v-toolbar-title>
											<v-spacer></v-spacer>
											<v-btn outlined class="mx-3" @click="onPreviewClear(sheet)" >
												<v-icon>mdi-broom</v-icon>
												Очистити
											</v-btn>
											<v-btn outlined @click="onPreviewRefresh(sheet)" >
												<v-icon>mdi-refresh</v-icon>
												Сформувати
											</v-btn>
										</v-toolbar>
										<v-card-text>
											<v-data-table
												:headers="sheet.preview.headers"
												:items="sheet.preview.items"
												:items-per-page="5"
												no-data-text="Для успішного імпорту даних необхідно їх сформувати"	
												no-results-text="Дані сформувати не вдалося"
											></v-data-table>
										</v-card-text>
									</v-card>
								</v-tab-item>
							</v-tabs-items>
						</v-card-text>
					</v-card>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>
		
		<v-file-input class="d-none"
			v-model="file.data"
			ref="File"
			:accept="accept"
			@change="changeFile"
		></v-file-input>

		<v-file-input class="d-none"
			v-model="file.settings.content"
			ref="FileSettings"
			:accept="file.settings.accept"
			@change="changeFileSettings"
		></v-file-input>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import * as XLSX from 'xlsx'; //https://www.npmjs.com/package/xlsx

export default {
	name: 'ImportExcel',
	components: {},
	data: () => ({
		dialog: false,
		fullscreen: true,
		loading: false,
		tab: 0,
		
		file: {
			name: null,
			sheets: [],
			data: null,
			/* data: {
				content: null
			}, */
			settings: {
				name: 'Імпорт.Налаштування.json',
				accept: 'application/json',
				content: null
			}
		},

		/* fields: [
			{ code: 'idMorion', name: 'Код Моріон', type: 'int' },
			{ code: 'name', name: 'Назва', type: 'string' },
			{ code: 'price', name: 'Ціна', type: 'float' },
			{ code: 'vat', name: 'Ставка ПДВ', type: 'float' },
			{ code: 'quantity', name: 'Кількість одиниць', type: 'float' },
			{ code: 'idExternal', name: 'Ідентифікатор зовнішньої системи', type: 'int' },
		], */
	}),
	props: {
		title:  		{ type: String, default: 'Імпорт'},
		tooltip:  		{ type: String, default: 'Імпорт'},
		icon:  			{ type: String, default: 'mdi-import'},
		maxWidth: 		{ type: [String,Number], default: 800 },
		//selected: 		{ type: Object, default: () => {} },
		disabled:   	{ type: Boolean, default: false }, //Ознака неактивного елементу

		accept:  		{ type: String, default: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
		headers:		{ type: Array, default: () => [] },

		fields:		{ type: Array, default: () => [] },
	},

	computed: {
		
	},

	methods: {
		onLoadFile() {
			this.$refs.File.$refs.input.click()
		},

		changeFile(files) {
			if(Array.isArray(files)) {
				files.forEach((file) => this.processFile(file))
			} else {
				this.processFile(files)
			}
		},

		/**
		 * Обробка файлу
		 * @param file 
		 */
		processFile(file) {
			if (file) {
				this.file.name = file.name;
				const fileName = file.name;
				const lastDotIndex = fileName.lastIndexOf('.');
				const fileExtension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex + 1) : null
				
				switch(fileExtension) {
					case 'xlsx': this.processFileExcel(file); break;
				}
			}
		},

		/**
		 * Обробка файлу Excel
		 * @param file 
		 */
		processFileExcel(file) {
			let that = this

			if (file) {
				const reader = new FileReader();

				reader.onload = (e) => {
					//console.log(this.$options.name, 'processFileExcel', 'XLSX', XLSX)
					
					const bstr = e.target.result;
					const workbook = XLSX.read(bstr, { type: 'binary' });
					workbook.SheetNames.forEach(name => {
						const worksheet = workbook.Sheets[name];

						const data 	= XLSX.utils.sheet_to_json(worksheet, { header: 1 });

						const firstrow = data.slice(0, 1)[0];
						const headers = firstrow.map((row, i) => {
							return { text: that.convertToExcelColumn(i+1), value: that.convertToExcelColumn(i+1), field: null};
						});

						const items = data.map((row, i) => {
							let obj = {}
							headers.forEach((item, c) => obj[item.value] = row[c])
							return obj
						});

						that.file.sheets.push({ 
							name: name,
							headers: headers,
							items: items,
							data: data,
							row: {
								start: 2,
								end: data.length,
								count: data.length,
							},
							preview: {
								headers: [],
								items: [],
							}
						})
					});

					//console.log(that.$options.name, 'processFileExcel', 'file', that.file)
				}

				reader.readAsArrayBuffer(this.file.data);
			}
		},

		onPreviewRefresh(sheet) {
			//console.log(this.$options.name, 'onPreviewRefresh', 'sheet.headers', sheet.headers)

			const headers = sheet.headers.map((item, i) => {
				return { text: item?.field?.name, value: item?.field?.code, valindex: i };
			}).filter((item) => item.value !== undefined)

			//console.log(this.$options.name, 'onPreviewRefresh', 'headers', headers)

			// Групування масиву заголовків полів
			const grouped_headers = Object.values(headers.reduce((acc, item) => {
				// Визначаємо ключ, за яким групуємо
				const key = item.value;

				if (!acc[key]) {
					// Якщо такого ключа ще немає, створюємо структуру
					acc[key] = { 
						text: item.text, 
						value: item.value, 
						details: [] // сюди будемо складати інші параметри
					};
				}

				acc[key].details.push(item.valindex);

				return acc;

			}, {}));

			//console.log(this.$options.name, 'onPreviewRefresh', 'grouped_headers', grouped_headers)

			const data = sheet.data.slice(sheet.row.start - 1, sheet.row.end - sheet.row.start);

			//console.log(this.$options.name, 'onPreviewRefresh', 'data', data)

			const items = data.map((row, i) => {
				let obj = {}
				grouped_headers.forEach((item, c) => { 
					obj[item.value] = item.details.map(fieldName => row[fieldName]).join('; ');
				})
				return obj
			});

			//console.log(this.$options.name, 'onPreviewRefresh', 'items', items)

			sheet.preview.headers = grouped_headers;
			sheet.preview.items = items;
		},

		onPreviewClear(sheet) {
			sheet.preview.items = [];
		},
		
		onCancel () {
			this.dialog = false
		},

		onOK () {
			

			let result = []

			// Об'єднання таблиць
			this.file.sheets.forEach((sheet) => result.push(...sheet.preview.items))

			//console.log(this.$options.name, 'onOK', 'result', result)

			this.$emit('ok', result)
			
			this.dialog = false
		},

		/**
		 * Функція для перетворення цифрового значення в літерні назви стовпців Excel (наприклад, 1 → A, 2 → B, 27 → AA)
		 * @param num 
		 */
		convertToExcelColumn(num) {
			let column = '';
			let tempNum = num;

			while (tempNum > 0) {
				let remainder = tempNum % 26;
				
				// Якщо залишок 0, це Z.
				// Зменшуємо tempNum, щоб уникнути нескінченного циклу і перейти до попереднього "розряду"
				if (remainder === 0) {
					column = 'Z' + column;
					tempNum = (tempNum / 26) - 1;
				} else {
					// Використовуємо ASCII-код, щоб отримати літеру (65 - це 'A')
					column = String.fromCharCode(64 + remainder) + column;
					tempNum = Math.floor(tempNum / 26);
				}
			}

			return column;
		},

		/**
		 * Функція, що перетворює літерне позначення стовпця Excel на його числовий еквівалент
		 * @param column 
		 */
		convertFromExcelColumn(column) {
			let result = 0;
			let multiplier = 1;

			// Проходимо по рядку справа наліво
			for (let i = column.length - 1; i >= 0; i--) {
				// Визначаємо числове значення літери (A=1, B=2, ...)
				const charValue = column.charCodeAt(i) - 64;
				
				// Додаємо значення, помножене на відповідну степінь 26
				result += charValue * multiplier;
				
				// Збільшуємо множник для наступної ітерації (26^0, 26^1, 26^2...)
				multiplier *= 26;
			}
			
			return result;
		},

		/**
		 * Функція створення глибоко вкладених об'єктів на основі рядка
		 * @param obj 
		 * @param path 
		 * @param value 
		 */
		createNestedProperty(obj, path, value) {
			//console.log(this.$options.name, 'createNestedProperty', 'path', path)

			// Розділяємо шлях на окремі ключі
			const keys = path.split('.');
			
			// Починаємо з кореневого об'єкта
			let current = obj;
			
			// Проходимо по всіх ключах, крім останнього
			for (let i = 0; i < keys.length - 1; i++) {
				const key = keys[i];
				
				// Якщо поточного ключа не існує або він не є об'єктом, створюємо його
				if (!current[key] || typeof current[key] !== 'object') {
					current[key] = {};
				}
				
				// Переходимо на наступний рівень вкладеності
				current = current[key];
			}
			
			// Присвоюємо значення останньому ключу
			const lastKey = keys[keys.length - 1];
			current[lastKey] = value;
		},

		/**
		 * Завантаження файлу Налаштувань
		 * Load JSON
		 */
		onLoadSettings() {
			this.file.settings.content = null
			this.$refs.FileSettings.$refs.input.click()
		},

		changeFileSettings (e) {
			//JSON.parse

			const file = this.file.settings.content;
			if (file) {
				const reader = new FileReader();
				reader.onload = (e) => {
					try {
						this.item = JSON.parse(e.target.result);
						/* let jsonData = JSON.parse(e.target.result);
						if(jsonData?.headers) {
							this.headers.splice(0, this.headers.length);
							jsonData.headers.forEach((element) => this.headers.push(element))
						} */
					} catch (error) {
						console.error("Error parsing JSON:", error);
						//this.jsonData = null; // Clear data on error
						alert("Invalid JSON file.");
					}
				};

				reader.readAsText(file);
			} else {
				//this.jsonData = null; // Clear data if no file selected
			}
		},

		/**
		 * Збереження файлу Налаштувань
		 * Save JSON
		 */
		onSaveSettings() {

			const filename = this.file.settings.name;
			/* const text = JSON.stringify({
				headers: this.headers
			}); */
			const text = JSON.stringify(this.item);

			const blob = new Blob([text], { type: 'application/json' });
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);
			URL.revokeObjectURL(url);
		}
	},
}
</script>